import { render, staticRenderFns } from "./BlockchainTestDashboard.vue?vue&type=template&id=072c9b54&scoped=true"
import script from "./BlockchainTestDashboard.vue?vue&type=script&lang=js"
export * from "./BlockchainTestDashboard.vue?vue&type=script&lang=js"
import style0 from "./BlockchainTestDashboard.vue?vue&type=style&index=0&id=072c9b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c9b54",
  null
  
)

export default component.exports